import { useEffect, useState } from "react";

export const useTheme = () => {
    const [theme, setTheme] = useState<string>(() => {
        // Check the initial theme
        if (typeof window !== "undefined") {
            return localStorage.getItem("theme") || "light";
        }
        return "light";
    });

    useEffect(() => {
        // Apply the theme class to the document's root element
        if (typeof window !== "undefined") {
            const root = window.document.documentElement;
            root.classList.remove(theme === "light" ? "dark" : "light");
            root.classList.add(theme);

            // Store theme in local storage
            localStorage.setItem("theme", theme);
        }
    }, [theme]);

    const setSystemTheme = () => {
        const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light";
        setTheme(systemTheme);
    };

    return { theme, setTheme, setSystemTheme };
};
